import type { SVGProps } from 'react';
import {
  Anthropic,
  Bfl,
  ByteDance,
  Claude,
  DeepSeek,
  ElevenLabs,
  Fal,
  Gemini,
  Google,
  Grok,
  Ideogram,
  Jimeng,
  Kling,
  Krea,
  Luma,
  Midjourney,
  Microsoft,
  Nvidia,
  Minimax,
  OpenAI,
  Qwen,
  Recraft,
  Replicate,
  Runway,
  Stability,
  Suno,
  TopazLabs,
  Vercel,
  Vidu,
  XAI,
  Zhipu,
  PixVerse,
  Moonshot,
  XiaomiMiMo,
  Skywork,
} from '@lobehub/icons';

export { FlowMuseIcon } from './flowmuse-icon';
export { HunyuanIcon, Hyper3dIcon, Tripo3dIcon } from './hunyuan-icon';
export { MurekaIcon } from './mureka-icon';
export { ReveIcon } from './reve-icon';

export const OpenAiIcon = (props: SVGProps<SVGSVGElement>) => (
  <OpenAI {...props} />
);

export const XaiIcon = (props: SVGProps<SVGSVGElement>) => (
  <XAI {...props} />
);

export const AnthropicIcon = (props: SVGProps<SVGSVGElement>) => (
  <Anthropic {...props} />
);

export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <Google.Color {...props} />
);

export const DeepSeekIcon = (props: SVGProps<SVGSVGElement>) => (
  <DeepSeek.Color {...props} />
);

export const FalIcon = (props: SVGProps<SVGSVGElement>) => (
  <Fal.Color {...props} />
);

export const LumaIcon = (props: SVGProps<SVGSVGElement>) => (
  <Luma.Color {...props} />
);

export const ReplicateIcon = (props: SVGProps<SVGSVGElement>) => (
  <Replicate {...props} />
);

export const MinimaxIcon = (props: SVGProps<SVGSVGElement>) => (
  <Minimax.Color {...props} />
);

export const RunwayIcon = (props: SVGProps<SVGSVGElement>) => (
  <Runway {...props} />
);

export const BlackForestLabsIcon = (props: SVGProps<SVGSVGElement>) => (
  <Bfl {...props} />
);

export const VercelIcon = (props: SVGProps<SVGSVGElement>) => (
  <Vercel {...props} />
);

export const GrokIcon = (props: SVGProps<SVGSVGElement>) => (
  <Grok {...props} />
);

export const ClaudeIcon = (props: SVGProps<SVGSVGElement>) => (
  <Claude.Color {...props} />
);

export const GeminiIcon = (props: SVGProps<SVGSVGElement>) => (
  <Gemini.Color {...props} />
);

export const AlibabaCloudIcon = (props: SVGProps<SVGSVGElement>) => (
  <Qwen {...props} />
);

export const KlingIcon = (props: SVGProps<SVGSVGElement>) => (
  <Kling.Color {...props} />
);

export const MidjourneyIcon = (props: SVGProps<SVGSVGElement>) => (
  <Midjourney {...props} />
);

export const JimengIcon = (props: SVGProps<SVGSVGElement>) => (
  <Jimeng {...props} />
);

export const BytedanceIcon = (props: SVGProps<SVGSVGElement>) => (
  <ByteDance.Color {...props} />
);

export const RecraftIcon = (props: SVGProps<SVGSVGElement>) => (
  <Recraft {...props} />
);

export const StableIcon = (props: SVGProps<SVGSVGElement>) => (
  <Stability.Color {...props} />
);

export const TopazIcon = (props: SVGProps<SVGSVGElement>) => (
  <TopazLabs {...props} />
);

export const ElevenLabsIcon = (props: SVGProps<SVGSVGElement>) => (
  <ElevenLabs {...props} />
);

export const ViduIcon = (props: SVGProps<SVGSVGElement>) => (
  <Vidu.Color {...props} />
);

export const SunoIcon = (props: SVGProps<SVGSVGElement>) => (
  <Suno {...props} />
);

export const ZhipuIcon = (props: SVGProps<SVGSVGElement>) => (
  <Zhipu.Color {...props} />
);

export const PixverseIcon = (props: SVGProps<SVGSVGElement>) => (
  <PixVerse {...props} />
);

export const MoonshotIcon = (props: SVGProps<SVGSVGElement>) => (
  <Moonshot {...props} />
);

export const XiaomiIcon = (props: SVGProps<SVGSVGElement>) => (
  <XiaomiMiMo {...props} />
);

export const IdeogramIcon = (props: SVGProps<SVGSVGElement>) => (
  <Ideogram {...props} />
);

export const KreaIcon = (props: SVGProps<SVGSVGElement>) => (
  <Krea {...props} />
);

export const MicrosoftIcon = (props: SVGProps<SVGSVGElement>) => (
  <Microsoft {...props} />
);

export const NvidiaIcon = (props: SVGProps<SVGSVGElement>) => (
  <Nvidia.Color {...props} />
);

export const SkyworkIcon = (props: SVGProps<SVGSVGElement>) => (
  <Skywork.Color {...props} />
);